import type { ReactNode } from 'react';

interface SummaryRowProps {
  label: string;
  value: ReactNode;
}

export function SummaryRow({ label, value }: SummaryRowProps) {
  return (
    <div className="grid grid-cols-[auto_1fr] gap-x-4 items-baseline text-sm">
      <span className="text-foreground/50">{label}</span>
      <span className="font-medium text-foreground text-right break-words [overflow-wrap:anywhere]">
        {value}
      </span>
    </div>
  );
}
